<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct" id="revolution"><a id="page33"></a><a href="#/5TOC#rev">REVOLUTION</a></h1>
<p class="noind"><i>Of course, the entire effort is to put oneself</i></p>
<p class="noind"><i>Outside the ordinary range</i></p>
<p class="noind"><i>Of what are called statistics.</i></p>
<p class="txr">—<span class="small">STEPHEN SPENDER</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10-revolution.vue?1ff77779